import { useTranslation } from 'react-i18next'
import { useGetApiMe } from '@/api/generated/user/user'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/shadcn/dialog'
import { Separator } from '@/components/shadcn/separator'

function getInitials(firstName?: string | null, lastName?: string | null) {
  return [firstName, lastName]
    .filter(Boolean)
    .map((n) => n![0].toUpperCase())
    .join('')
}

interface Props {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export function ProfileDialog({ isOpen, onOpenChange }: Props) {
  const { t } = useTranslation('profile')
  const { data: meData } = useGetApiMe()
  const me = meData?.data

  const initials = getInitials(me?.firstName, me?.lastName) || '?'
  const fullName = [me?.firstName, me?.lastName].filter(Boolean).join(' ') || '—'

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('dialog.title')}</DialogTitle>
          <DialogDescription>{t('dialog.description')}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-4 text-center pt-2">
          <div className="h-24 w-24 rounded-full bg-primary/10 border-4 border-background shadow-lg flex items-center justify-center text-primary text-3xl font-bold select-none">
            {initials}
          </div>
          <p className="font-semibold text-base">{fullName}</p>
        </div>

        <Separator />

        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{t('dialog.fields.firstName')}</span>
            <span className="text-sm">{me?.firstName || '—'}</span>
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{t('dialog.fields.lastName')}</span>
            <span className="text-sm">{me?.lastName || '—'}</span>
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{t('dialog.fields.email')}</span>
            <span className="text-sm break-all">{me?.email || '—'}</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
